import IconBadge from "../../../../components/StatusCell/IconBadge";
import {IconButton} from "@mui/material";


export const getDataTableData = (t, updateApprovePermissionClick, updateManagePermissionClick,disabledButton)  => {
 

    return {
      columns: [
        {
            id: "Resource",
            label: "projectPermission.list.column.resource",
            align: "left",
            visible: true,
            renderCell: (row) => {
              return (row?.resource?.firstName || "") + " " + (row?.resource?.lastName || "")
            },
          },
          {
            id: "IsTimesheetApprover",
            label: "projectPermission.list.column.isTimesheetApprover",
            align: "center",
            visible: true,
            renderCell: (row) => {
              if(!disabledButton)
              {return   <IconButton onClick={()=>updateApprovePermissionClick(row)} sx={{ marginLeft: "30px", padding: 0 }} color="primary" aria-label="add task">
              {row?.isTimesheetApprover ? <IconBadge success={true} /> : <IconBadge success={false} />}
                    </IconButton>
               }
              return row?.isTimesheetApprover ? <IconBadge success={true} /> : <IconBadge success={false} />
              },
          },
          {
            id: "CanManageTimeEntries",
            label: "projectPermission.list.column.canManageTimeEntries",
            align: "center",
            visible: true,
            
            renderCell: (row) => {
             
              if(!disabledButton)
                {
               return <IconButton onClick={()=>updateManagePermissionClick(row)} sx={{ marginLeft: "30px", padding: 0 }} color="primary" aria-label="add task">
       {row?.canManageTimeEntries ? <IconBadge success={true} /> : <IconBadge success={false} />}
             </IconButton>}
             return row?.canManageTimeEntries ? <IconBadge success={true} /> : <IconBadge success={false} />
            },
           },
      ],
    };
  };
  